exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".row[_v-6eaf7c52]:first-of-type{padding-top:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-6eaf7c52&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Product/Product-detail-images.vue
// module id = 441
// module chunks = 0